export enum apiUrl {
    BUSINESS_DETAILS = '/v1/external-businesses',
    EVENT_DETAILS = '/v1/external-events',
    EXTERNAL_EVENTS = '/v1/external-events',
    EXTERNAL_BUSINESS = '/v1/external-businesses',
    WAREHOUSE_EVENTS = '/v1/scrapped-events',
}
